module.exports = __webpack_public_path__ + "img/yahoo.5db2aa82.png";